import React, { Component } from 'react';
import NavigationSelection from './NavigationSelection.js';
import CustomizePage from './CustomizePage.js';
import StatsPage from './StatsPage.js';

class ContentController extends Component {

    constructor(props) {
        super(props);
        this.state = { 
            activeTab: 'twitch-client',
            login: 'user',
        };

        this.activeTab = this.activeTab.bind(this);
    }

    activeTab(tab) {
        this.setState({
            activeTab: tab
        });
    }

    render() {
        return (
            <div className="mb-container">
                <NavigationSelection
                    entries={[
                        {
                            url: '/twitch.png',
                            key: 'twitch-client'
                        },
                        {
                            url: '/marble.png',
                            key: 'customize'
                        },
                        {
                            url: '/graph.png',
                            key: 'stats'
                        }
                    ]}
                    callback={this.activeTab}
                    activeTab={this.state.activeTab}
                />
                <div className="mb-content">
                    { this.state.activeTab === 'twitch-client' ? 
                    <iframe
                        title="Twitch Player"
                        src="http://player.twitch.tv/?channel=marbleer"
                        height="586"
                        width="100%"
                        frameBorder="0"
                        scrolling="true"
                        allowFullScreen="true">
                    </iframe>
                    : null}

                    { this.state.activeTab === 'customize' ?
                        <CustomizePage />
                    : null}

                    { this.state.activeTab === 'stats' ?
                        <StatsPage />
                    : null}

                </div>
            </div>
        )
    }
}

export default ContentController; // Don’t forget to use export default!


// WEBPACK FOOTER //
// ./src/ContentController.js